<span [ngClass]="value ? 'complete' : ''"></span>